import { css } from '@emotion/core'
import styled from '@emotion/styled'

import { Link, NativeLink, palette, Text } from 'main/ui'

const textStyles = css`
  color: ${palette.slate};
  font-size: 14px;
  line-height: 21px;
`

export const StyledText = styled(Text)(textStyles)
export const StyledNativeLink = styled(NativeLink)(textStyles)
export const StyledLink = styled(Link)(textStyles)
